import { render, staticRenderFns } from "./SimpleRule.vue?vue&type=template&id=0fecb39a&scoped=true"
import script from "./SimpleRule.vue?vue&type=script&lang=js"
export * from "./SimpleRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fecb39a",
  null
  
)

export default component.exports